<template>
  <div class="collapse-edit-warp relative">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <menu-divider />
    <menu-item class="menu-item-switch" :label="$t('menu.layout')">
      <!-- 标题 -->
      <menu-switch
        v-model="model.titleVisible"
        :label="$t('menu.title')"
        target-key="titleVisible"
      />
      <menu-switch v-model="model.isExpand" target-key="isExpand" label="默认全部展开" />
      <!-- 布局方式 -->
      <menu-select
        v-model="model.layoutMethod"
        :icon="true"
        :options="layoutMethodOptions"
        label="布局方式"
        olabel="label"
        oval="value"
        mkey="value"
        target-key="layoutMethod"
        class="collapse-methods_select mt-4"
        @change="(v)=> model.layoutMethod = v"
      />
    </menu-item>
    <menu-divider />
    <menu-item label="箭头颜色">
      <menu-fill
        target-key="arrow"
        solid-color
        :target="model.arrow"
      ></menu-fill>
    </menu-item>
    <menu-item label="折叠颜色">
      <menu-fill
        target-key="bgConfig"
        solid-color
        :target="model.bgConfig"
      />
    </menu-item>
    <menu-item label="描述背景色">
      <menu-fill target-key="descBackground" solid-color :target="model.descBackground" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem";
import MenuSwitch from "~/components/menu/menuSwitch";
import MenuSelect from "~/components/menu/menuSelect";
import MenuDivider from "~/components/menu/divider.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";

export default {
  name: 'CollapseWidgetEdit',
  components: {
    MenuBackgroundImage,
    MenuFill,
    MenuDivider,
    MenuItem,
    MenuSwitch,
    MenuSelect
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    device: {
      type: String,
      default: 'desktop',
    },
  },
  data() {
    return {
      layoutMethodOptions: [
        {
          label: '横向布局',
          value: 'horizontal'
        },
        {
          label: '纵向布局',
          value: 'vertical',
        }
      ]
    }
  },
  methods: {
    handleShowBackgroundMenu() {
      this.$parent && this.$parent.selectSubmenu('background', this.model)
    },
  }
}
</script>

<style lang="less" scoped>
.collapse-edit-warp {
  .collapse-layout-method__wrapper {
    @apply p-2 mt-2;
    background: @fill-color-2;
  }
}
</style>
<style lang="less">
.collapse-methods_select {
  .label {
    color: #fff !important;
  }
}
</style>
